export default __webpack_public_path__ + "static/media/Group_432.8f9bce6a.svg";